import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_2 = {
    key: 0,
    class: "bottom10"
};
const _hoisted_3 = { class: "mt-0" };
const _hoisted_4 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_5 = { class: "input-group top_search" };
const _hoisted_6 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_7 = { class: "input-group top_search" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-4 bottom10" };
const _hoisted_9 = { class: "invalid-feedback" };
const _hoisted_10 = { class: "col-xs-12 col-sm-12 col-md-4 bottom10" };
const _hoisted_11 = { class: "invalid-feedback" };
const _hoisted_12 = { class: "col-xs-12 col-sm-12 col-md-4 bottom10" };
const _hoisted_13 = { class: "invalid-feedback" };
const _hoisted_14 = { class: "col-xs-12 col-sm-12 col-md-4 bottom10" };
const _hoisted_15 = { class: "invalid-feedback" };
const _hoisted_16 = { class: "col-xs-12 col-sm-12 col-md-4 bottom10" };
const _hoisted_17 = { class: "invalid-feedback" };
const _hoisted_18 = { class: "col-xs-12 col-sm-12 col-md-4 bottom10" };
const _hoisted_19 = { class: "invalid-feedback" };
const _hoisted_20 = { class: "col-xs-12 col-sm-12 col-md-4 bottom10" };
const _hoisted_21 = { class: "invalid-feedback" };
const _hoisted_22 = { class: "col-xs-12 col-sm-12 col-md-4 bottom10" };
const _hoisted_23 = { class: "invalid-feedback" };
const _hoisted_24 = { class: "col-xs-12 col-sm-12 col-md-4 bottom10" };
const _hoisted_25 = { class: "invalid-feedback" };
const _hoisted_26 = { class: "col-xs-12 col-sm-12 col-md-4 bottom10" };
const _hoisted_27 = { class: "invalid-feedback" };
const _hoisted_28 = { class: "col-xs-12 col-sm-12 col-md-4 bottom10" };
const _hoisted_29 = { class: "invalid-feedback" };
const _hoisted_30 = { class: "col-xs-12 col-sm-12 col-md-4 bottom10" };
const _hoisted_31 = { class: "invalid-feedback" };
const _hoisted_32 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_33 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_34 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_35 = { class: "float-end float-start-sm" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_radio = _resolveComponent("b-form-radio");
    const _component_b_form_group = _resolveComponent("b-form-group");
    const _component_b_button = _resolveComponent("b-button");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    const _directive_standard_or_higher = _resolveDirective("standard-or-higher");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            (_ctx.reportScheduledModel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("h2", _hoisted_3, [
                        _cache[18] || (_cache[18] = _createTextVNode("Editing schedule report ", -1 /* CACHED */)),
                        _createElementVNode("b", null, _toDisplayString(_ctx.reportScheduledModel.description), 1 /* TEXT */)
                    ])
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        _cache[87] || (_cache[87] = _createTextVNode()),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedCompanyId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCompanyId) = $event)),
                    options: _ctx.companies,
                    "track-by": "value",
                    label: "text",
                    showLabels: false,
                    placeholder: "All companies",
                    class: "multiselect-small"
                }, {
                    noResult: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                            _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
            ])
        ]),
        _cache[88] || (_cache[88] = _createTextVNode()),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedSite,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedSite) = $event)),
                    options: _ctx.sitesFiltered,
                    "track-by": "value",
                    label: "text",
                    showLabels: false,
                    placeholder: "Any site",
                    class: "multiselect-small"
                }, {
                    noResult: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                            _createTextVNode("\r\n\t\t\t\t\tNo results found\r\n\t\t\t\t", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "options"])
            ])
        ]),
        _cache[89] || (_cache[89] = _createTextVNode()),
        _withDirectives(_createElementVNode("div", null, [
            _cache[57] || (_cache[57] = _createElementVNode("div", { class: "col-xs-12 col-sm-12 col-md-12" }, [
                _createElementVNode("h5", null, "Age (yrs)")
            ], -1 /* CACHED */)),
            _cache[58] || (_cache[58] = _createTextVNode()),
            _createElementVNode("div", _hoisted_8, [
                _cache[21] || (_cache[21] = _createElementVNode("label", null, "\r\n\t\t\t\tLower Range\r\n\t\t\t", -1 /* CACHED */)),
                _cache[22] || (_cache[22] = _createTextVNode()),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.ageColumn1Val, {
                    type: "number",
                    modelValue: _ctx.query.ageColumn1Parameter,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.ageColumn1Parameter) = $event)),
                    modelModifiers: { trim: true },
                    min: "0",
                    max: "100",
                    step: "1",
                    class: { 'is-invalid': (_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.ageColumn1 }
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _cache[23] || (_cache[23] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_9, "\r\n\t\t\t\t* Please enter a value between 0 and 100.\r\n\t\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, (_b = _ctx.errors) === null || _b === void 0 ? void 0 : _b.ageColumn1]
                ])
            ]),
            _cache[59] || (_cache[59] = _createTextVNode()),
            _createElementVNode("div", _hoisted_10, [
                _cache[24] || (_cache[24] = _createElementVNode("label", null, "\r\n\t\t\t\tMiddle Range\r\n\t\t\t", -1 /* CACHED */)),
                _cache[25] || (_cache[25] = _createTextVNode()),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.ageColumn2Val, {
                    type: "number",
                    modelValue: _ctx.query.ageColumn2Parameter,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.ageColumn2Parameter) = $event)),
                    modelModifiers: { trim: true },
                    min: "0",
                    max: "100",
                    step: "1",
                    class: { 'is-invalid': (_c = _ctx.errors) === null || _c === void 0 ? void 0 : _c.ageColumn2 }
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _cache[26] || (_cache[26] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_11, "\r\n\t\t\t\t* Please enter a value between 0 and 100.\r\n\t\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, (_d = _ctx.errors) === null || _d === void 0 ? void 0 : _d.ageColumn2]
                ])
            ]),
            _cache[60] || (_cache[60] = _createTextVNode()),
            _createElementVNode("div", _hoisted_12, [
                _cache[27] || (_cache[27] = _createElementVNode("label", null, "\r\n\t\t\t\tUpper Range\r\n\t\t\t", -1 /* CACHED */)),
                _cache[28] || (_cache[28] = _createTextVNode()),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.ageColumn3Val, {
                    type: "number",
                    modelValue: _ctx.query.ageColumn3Parameter,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.query.ageColumn3Parameter) = $event)),
                    modelModifiers: { trim: true },
                    min: "0",
                    max: "100",
                    step: "1",
                    class: { 'is-invalid': (_e = _ctx.errors) === null || _e === void 0 ? void 0 : _e.ageColumn3 }
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _cache[29] || (_cache[29] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_13, "\r\n\t\t\t\t* Please enter a value between 0 and 100.\r\n\t\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, (_f = _ctx.errors) === null || _f === void 0 ? void 0 : _f.ageColumn3]
                ])
            ]),
            _cache[61] || (_cache[61] = _createTextVNode()),
            _cache[62] || (_cache[62] = _createElementVNode("div", { class: "col-xs-12 col-sm-12 col-md-12" }, [
                _createElementVNode("h5", null, "Replacement (%)")
            ], -1 /* CACHED */)),
            _cache[63] || (_cache[63] = _createTextVNode()),
            _createElementVNode("div", _hoisted_14, [
                _cache[30] || (_cache[30] = _createElementVNode("label", null, "\r\n\t\t\t\tLower Range\r\n\t\t\t", -1 /* CACHED */)),
                _cache[31] || (_cache[31] = _createTextVNode()),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.replacementColumn1Val, {
                    type: "number",
                    modelValue: _ctx.query.replacementColumn1Parameter,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.query.replacementColumn1Parameter) = $event)),
                    modelModifiers: { trim: true },
                    min: "0",
                    max: "100",
                    step: "1",
                    class: { 'is-invalid': (_g = _ctx.errors) === null || _g === void 0 ? void 0 : _g.replacementColumn1 }
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _cache[32] || (_cache[32] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_15, "\r\n\t\t\t\t* Please enter a value between 0 and 100.\r\n\t\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, (_h = _ctx.errors) === null || _h === void 0 ? void 0 : _h.replacementColumn1]
                ])
            ]),
            _cache[64] || (_cache[64] = _createTextVNode()),
            _createElementVNode("div", _hoisted_16, [
                _cache[33] || (_cache[33] = _createElementVNode("label", null, "\r\n\t\t\t\tMiddle Range\r\n\t\t\t", -1 /* CACHED */)),
                _cache[34] || (_cache[34] = _createTextVNode()),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.replacementColumn2Val, {
                    type: "number",
                    modelValue: _ctx.query.replacementColumn2Parameter,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.query.replacementColumn2Parameter) = $event)),
                    modelModifiers: { trim: true },
                    min: "0",
                    max: "100",
                    step: "1",
                    class: { 'is-invalid': (_j = _ctx.errors) === null || _j === void 0 ? void 0 : _j.replacementColumn2 }
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _cache[35] || (_cache[35] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_17, "\r\n\t\t\t\t* Please enter a value between 0 and 100.\r\n\t\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, (_k = _ctx.errors) === null || _k === void 0 ? void 0 : _k.replacementColumn2]
                ])
            ]),
            _cache[65] || (_cache[65] = _createTextVNode()),
            _createElementVNode("div", _hoisted_18, [
                _cache[36] || (_cache[36] = _createElementVNode("label", null, "\r\n\t\t\t\tUpper Range\r\n\t\t\t", -1 /* CACHED */)),
                _cache[37] || (_cache[37] = _createTextVNode()),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.replacementColumn3Val, {
                    type: "number",
                    modelValue: _ctx.query.replacementColumn3Parameter,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.query.replacementColumn3Parameter) = $event)),
                    modelModifiers: { trim: true },
                    min: "0",
                    max: "100",
                    step: "1",
                    class: { 'is-invalid': (_l = _ctx.errors) === null || _l === void 0 ? void 0 : _l.replacementColumn3 }
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _cache[38] || (_cache[38] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_19, "\r\n\t\t\t\t* Please enter a value between 0 and 100.\r\n\t\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, (_m = _ctx.errors) === null || _m === void 0 ? void 0 : _m.replacementColumn3]
                ])
            ]),
            _cache[66] || (_cache[66] = _createTextVNode()),
            _cache[67] || (_cache[67] = _createElementVNode("div", { class: "col-xs-12 col-sm-12 col-md-12" }, [
                _createElementVNode("h5", null, "Ohmic Rise (%)")
            ], -1 /* CACHED */)),
            _cache[68] || (_cache[68] = _createTextVNode()),
            _createElementVNode("div", _hoisted_20, [
                _cache[39] || (_cache[39] = _createElementVNode("label", null, "\r\n\t\t\t\tLower Range\r\n\t\t\t", -1 /* CACHED */)),
                _cache[40] || (_cache[40] = _createTextVNode()),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.ohmicRiseColumn1Val, {
                    type: "number",
                    modelValue: _ctx.query.ohmicRiseColumn1Parameter,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.query.ohmicRiseColumn1Parameter) = $event)),
                    modelModifiers: { trim: true },
                    min: "0",
                    max: "100",
                    step: "1",
                    class: { 'is-invalid': (_o = _ctx.errors) === null || _o === void 0 ? void 0 : _o.ohmicRiseColumn1 }
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _cache[41] || (_cache[41] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_21, "\r\n\t\t\t\t* Please enter a value between 0 and 100.\r\n\t\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, (_p = _ctx.errors) === null || _p === void 0 ? void 0 : _p.ohmicRiseColumn1]
                ])
            ]),
            _cache[69] || (_cache[69] = _createTextVNode()),
            _createElementVNode("div", _hoisted_22, [
                _cache[42] || (_cache[42] = _createElementVNode("label", null, "\r\n\t\t\t\tMiddle Range\r\n\t\t\t", -1 /* CACHED */)),
                _cache[43] || (_cache[43] = _createTextVNode()),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.ohmicRiseColumn2Val, {
                    type: "number",
                    modelValue: _ctx.query.ohmicRiseColumn2Parameter,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.query.ohmicRiseColumn2Parameter) = $event)),
                    modelModifiers: { trim: true },
                    min: "0",
                    max: "100",
                    step: "1",
                    class: { 'is-invalid': (_q = _ctx.errors) === null || _q === void 0 ? void 0 : _q.ohmicRiseColumn2 }
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _cache[44] || (_cache[44] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_23, "\r\n\t\t\t\t* Please enter a value between 0 and 100.\r\n\t\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, (_r = _ctx.errors) === null || _r === void 0 ? void 0 : _r.ohmicRiseColumn2]
                ])
            ]),
            _cache[70] || (_cache[70] = _createTextVNode()),
            _createElementVNode("div", _hoisted_24, [
                _cache[45] || (_cache[45] = _createElementVNode("label", null, "\r\n\t\t\t\tUpper Range\r\n\t\t\t", -1 /* CACHED */)),
                _cache[46] || (_cache[46] = _createTextVNode()),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.ohmicRiseColumn3Val, {
                    type: "number",
                    modelValue: _ctx.query.ohmicRiseColumn3Parameter,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.query.ohmicRiseColumn3Parameter) = $event)),
                    modelModifiers: { trim: true },
                    min: "0",
                    max: "100",
                    step: "1",
                    class: { 'is-invalid': (_s = _ctx.errors) === null || _s === void 0 ? void 0 : _s.ohmicRiseColumn3 }
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _cache[47] || (_cache[47] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_25, "\r\n\t\t\t\t* Please enter a value between 0 and 100.\r\n\t\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, (_t = _ctx.errors) === null || _t === void 0 ? void 0 : _t.ohmicRiseColumn3]
                ])
            ]),
            _cache[71] || (_cache[71] = _createTextVNode()),
            _cache[72] || (_cache[72] = _createElementVNode("div", { class: "col-xs-12 col-sm-12 col-md-12" }, [
                _createElementVNode("h5", null, "End of Life Prediction (mths)")
            ], -1 /* CACHED */)),
            _cache[73] || (_cache[73] = _createTextVNode()),
            _createElementVNode("div", _hoisted_26, [
                _cache[48] || (_cache[48] = _createElementVNode("label", null, "\r\n\t\t\t\tLow Range\r\n\t\t\t", -1 /* CACHED */)),
                _cache[49] || (_cache[49] = _createTextVNode()),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.predictedColumn1Val, {
                    type: "number",
                    modelValue: _ctx.query.predictedColumn1Parameter,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.query.predictedColumn1Parameter) = $event)),
                    modelModifiers: { trim: true },
                    min: "0",
                    max: "100",
                    step: "1",
                    class: { 'is-invalid': (_u = _ctx.errors) === null || _u === void 0 ? void 0 : _u.predictedColumn1 }
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _cache[50] || (_cache[50] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_27, "\r\n\t\t\t\t* Please enter a value between 0 and 100.\r\n\t\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, (_v = _ctx.errors) === null || _v === void 0 ? void 0 : _v.predictedColumn1]
                ])
            ]),
            _cache[74] || (_cache[74] = _createTextVNode()),
            _createElementVNode("div", _hoisted_28, [
                _cache[51] || (_cache[51] = _createElementVNode("label", null, "\r\n\t\t\t\tMiddle Range\r\n\t\t\t", -1 /* CACHED */)),
                _cache[52] || (_cache[52] = _createTextVNode()),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.predictedColumn2Val, {
                    type: "number",
                    modelValue: _ctx.query.predictedColumn2Parameter,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.query.predictedColumn2Parameter) = $event)),
                    modelModifiers: { trim: true },
                    min: "0",
                    max: "100",
                    step: "1",
                    class: { 'is-invalid': (_w = _ctx.errors) === null || _w === void 0 ? void 0 : _w.predictedColumn2 }
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _cache[53] || (_cache[53] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_29, "\r\n\t\t\t\t* Please enter a value between 0 and 100.\r\n\t\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, (_x = _ctx.errors) === null || _x === void 0 ? void 0 : _x.predictedColumn2]
                ])
            ]),
            _cache[75] || (_cache[75] = _createTextVNode()),
            _createElementVNode("div", _hoisted_30, [
                _cache[54] || (_cache[54] = _createElementVNode("label", null, "\r\n\t\t\t\tUpper Range\r\n\t\t\t", -1 /* CACHED */)),
                _cache[55] || (_cache[55] = _createTextVNode()),
                _createVNode(_component_b_form_input, _mergeProps(_ctx.predictedColumn3Val, {
                    type: "number",
                    modelValue: _ctx.query.predictedColumn3Parameter,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.query.predictedColumn3Parameter) = $event)),
                    modelModifiers: { trim: true },
                    min: "0",
                    max: "100",
                    step: "1",
                    class: { 'is-invalid': (_y = _ctx.errors) === null || _y === void 0 ? void 0 : _y.predictedColumn3 }
                }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                _cache[56] || (_cache[56] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_31, "\r\n\t\t\t\t* Please enter a value between 0 and 100.\r\n\t\t\t", 512 /* NEED_PATCH */), [
                    [_vShow, (_z = _ctx.errors) === null || _z === void 0 ? void 0 : _z.predictedColumn3]
                ])
            ]),
            _cache[76] || (_cache[76] = _createTextVNode()),
            _createElementVNode("div", _hoisted_32, [
                _createElementVNode("a", {
                    class: "blue",
                    href: "#",
                    onClick: _cache[14] || (_cache[14] = ($event) => (_ctx.displayAdvancedFilter = false))
                }, "Hide advanced parameters")
            ])
        ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.displayAdvancedFilter]
        ]),
        _cache[90] || (_cache[90] = _createTextVNode()),
        _withDirectives(_createElementVNode("div", _hoisted_33, [
            _createElementVNode("a", {
                class: "blue",
                href: "#",
                onClick: _cache[15] || (_cache[15] = ($event) => (_ctx.displayAdvancedFilter = true))
            }, "Show advanced parameters")
        ], 512 /* NEED_PATCH */), [
            [_vShow, !_ctx.displayAdvancedFilter]
        ]),
        _cache[91] || (_cache[91] = _createTextVNode()),
        _createElementVNode("div", _hoisted_34, [
            _cache[80] || (_cache[80] = _createElementVNode("label", null, "String Age calculated by: ", -1 /* CACHED */)),
            _cache[81] || (_cache[81] = _createTextVNode()),
            _createVNode(_component_b_form_group, { label: "" }, {
                default: _withCtx(({ ariaDescribedby }) => [
                    _createVNode(_component_b_form_radio, {
                        inline: "",
                        modelValue: _ctx.query.ageMethod,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.query.ageMethod) = $event)),
                        "aria-describedby": ariaDescribedby,
                        name: "ageMethod",
                        value: "1"
                    }, {
                        default: _withCtx(() => [...(_cache[77] || (_cache[77] = [
                                _createTextVNode("String Installation Date", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "aria-describedby"]),
                    _cache[79] || (_cache[79] = _createTextVNode()),
                    _createVNode(_component_b_form_radio, {
                        inline: "",
                        modelValue: _ctx.query.ageMethod,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.query.ageMethod) = $event)),
                        "aria-describedby": ariaDescribedby,
                        name: "ageMethod",
                        value: "2"
                    }, {
                        default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                                _createTextVNode("Block Average Age", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "aria-describedby"])
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _cache[92] || (_cache[92] = _createTextVNode()),
        _cache[93] || (_cache[93] = _createElementVNode("div", { class: "float-start top10 ms-2" }, [
            _createElementVNode("label", null, "Note: the life prediction calculations are performed every seven days.")
        ], -1 /* CACHED */)),
        _cache[94] || (_cache[94] = _createTextVNode()),
        _createElementVNode("div", _hoisted_35, [
            _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.schedule
            }, {
                default: _withCtx(() => [
                    _cache[82] || (_cache[82] = _createElementVNode("i", { class: "fa fa-clock-o" }, null, -1 /* CACHED */)),
                    _createTextVNode(" " + _toDisplayString(_ctx.getScheduleButtonLabel()), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])), [
                [_directive_standard_or_higher]
            ]),
            _cache[85] || (_cache[85] = _createTextVNode()),
            _createVNode(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.exportToPdf
            }, {
                default: _withCtx(() => [...(_cache[83] || (_cache[83] = [
                        _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* CACHED */),
                        _createTextVNode(" Export PDF\r\n\t\t", -1 /* CACHED */)
                    ]))]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"]),
            _cache[86] || (_cache[86] = _createTextVNode()),
            _createVNode(_component_b_button, {
                type: "button",
                variant: "primary",
                onClick: _ctx.exportToCsv
            }, {
                default: _withCtx(() => [...(_cache[84] || (_cache[84] = [
                        _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* CACHED */),
                        _createTextVNode(" Export CSV\r\n\t\t", -1 /* CACHED */)
                    ]))]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"])
        ]),
        _cache[95] || (_cache[95] = _createTextVNode()),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ], 64 /* STABLE_FRAGMENT */));
}
